<div [hidden]="isHidden" [ngClass]="{'overlayholder': type === 'overlay', 'dropdown-loader': type === 'dropdown'}">
    <div class="progress-wrap">
      <div class="progress-bar"></div>
    </div>
  </div>